import { AppsGalleryIcon } from "../AppsGalleryIcon/AppsGalleryIcon";
import "./AppsGallery.css";
import { useEffect } from "react";

export function AppGallery({
    applications,
    onClose,
    onOpenApp,
    closing,
    zIndex,
    language,
}) {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    return (
        <div
            className={`app-gallery ${closing ? "app-gallery_closing" : ""}`}
            style={{ zIndex: zIndex }}
            onClick={(e) => onClose()}
        >
            <div
                className={`app-gallery_container ${
                    closing ? "app-gallery_container_closing" : ""
                }`}
                onClick={(e) => onClose()}
            >
                <div className="app-gallery_content">
                    {applications &&
                        applications
                            .filter((app) => app.visible)
                            .map((app, index) => (
                                <AppsGalleryIcon
                                    key={index}
                                    icon={app.icon}
                                    name={app.title[language]}
                                    command={app.command}
                                    hasNewTabIcon={app.newtabicon}
                                    onClick={onOpenApp}
                                />
                            ))}
                </div>
            </div>
        </div>
    );
}
